import { state } from './state.js';

export const preview = {
  async render() {
    const selections = state.getSelections();
    const previewEl = state.elements.previewEl;

    const imgs = state.steps
      .map(s => selections[s.id]?.image_avif || selections[s.id]?.image_webp || selections[s.id]?.image)
      .filter(Boolean);

    const firstSel = selections[state.steps[0]?.id];
    const titleEl = document.getElementById('acpb-preview-title');
    if (titleEl) titleEl.textContent = firstSel?.label || '';

    if (!imgs.length) {
      previewEl.innerHTML = '';
      return;
    }

    const layers = await Promise.all(
      imgs.map(src =>
        new Promise(resolve => {
          const img = new Image();
          img.className = 'acpb-layer';
          img.src = src;
          img.onload = () => resolve(img);
          img.onerror = () => resolve(img);
        })
      )
    );

    previewEl.innerHTML = '';
    layers.forEach(img => previewEl.appendChild(img));
  }
};
